module.exports = __webpack_public_path__ + "static/media/lamSach.cf219137.svg";